import { formatDate } from '@angular/common';
import { Component, Input } from '@angular/core';
import { BOOLEAN_MAPPER_CLASS, STATUS_MAPPER_CLASS } from '@app/shared/mappers/status.mapper';
import { READONLY_VALUE_TYPE, READONLY_DISPLAY_TYPE, DATETIME_DEFAULT_FORMAT, DATE_DEFAULT_FORMAT } from '@app/shared/types/enums';

@Component({
  selector: 'app-read-only',
  templateUrl: './read-only.component.html',
  styleUrls: ['./read-only.component.sass'],
})
export class ReadOnlyComponent {
  /**
   * Display type (row || col).
   */
  @Input() displayType: READONLY_DISPLAY_TYPE = 'row';
  /**
   * Type of the value to display and format.
   */
  @Input() valueType?: READONLY_VALUE_TYPE;
  /**
   * Key to display (title).
   */
  @Input() key = '';
  /**
   * Sub Key to display (subtitle).
   */
  @Input() subKey = '';
  /**
   * Value to display (if value Key is set, translation will be displayed).
   */
  @Input() value: any | null | undefined = '';
  /**
   * Translate Resource for value.
   */
  @Input() valueKey = '';
  /**
   * If border bottom need to be displayed.
   */
  @Input() applyBorderBottom = true;
  /**
   * Font size.
   */
  @Input() fontSize = 'fs-12';
  /**
   * Text color.
   */
  @Input() descColor = '';
  /**
   * Key text color.
   */
  @Input() keyColor = 'text-light-gray';
  /**
   * Style class to apply.
   */
  @Input() className = '';
  /**
   * Material icon name to display. Type 'icon' | 'iconText' value type must be set.
   */
  @Input() icon: string | undefined = '';
  /**
   * Type url.
   */
  @Input() url = '';
  /**
   * Add points before string .
   */
  @Input() pointsBefore = false;
  /**
   * iterator of number of points
   */
  @Input() numberOfPoints = 1;
  /**
   * Font size key.
   */
  @Input() keyFs = 'fs-12';
  // /**
  //  * Font size value.
  //  */
  @Input() valueFs = '14';
  // /**
  //  * Font width key.
  //  */
  @Input() keyFw = '400';

  /**
   * class for key
   */
  @Input() keyClass = '';

  /**
   * Font size sub key.
   */
  @Input() subKeyFs = 'fs-10';
  // /**
  // /**
  //  * Font width sub key.
  //  */
  @Input() subKeyFw = '400';

  /**
   * class for sub key
   */
  @Input() subKeyClass = '';

  // /**
  //  * Font width value.
  //  */
  @Input() valueFw = '600';

  defaultEmptyValue = '-';

  STATUS_MAPPER_CLASS = STATUS_MAPPER_CLASS;
  BOOLEAN_MAPPER_CLASS = BOOLEAN_MAPPER_CLASS;

  @Input()
  crossValueClass = 'fw-500';

  @Input() countryCurrency = false;

  DATETIME_DEFAULT_FORMAT = DATETIME_DEFAULT_FORMAT;
  DATE_DEFAULT_FORMAT = DATE_DEFAULT_FORMAT;

  constructor() {}

  get isRow(): boolean {
    return this.displayType === 'row';
  }

  arrayOfNumbers(n: number): number[] {
    return Array(n)
      .fill(0)
      .map((x, i) => i);
  }
}
